module.exports = __webpack_public_path__ + "static/media/total_theft.ff9a99cc.svg";